module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright_notice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("EARTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Beijing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2#pt2"
    }
  }, [_vm._v("ARRIVAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Awakening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("Data Bank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_vm._v("Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5"
    }
  }, [_vm._v("The News from Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6"
    }
  }, [_vm._v("Outcasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7"
    }
  }, [_vm._v("Examination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8"
    }
  }, [_vm._v("Brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Glow of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frustration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Departure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MOON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anita Halleck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENCOUNTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Administrative Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visitors’ Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebellion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Farms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guilt and Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camping Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Base Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s in a Name?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Examination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EARTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Washington, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DISCOVERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turnabout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motivations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reactions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shielding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aurora")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Factions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Racing Toward Extinction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conundrum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7#pt7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tithonium Base")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8#pt8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REVELATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Biolab")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unanswered Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Regime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollow Progress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Field Trip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sooner or Later")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surprise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter57#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confirmation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter58#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culture Shock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter59#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Security")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter60#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guests … or Prisoners?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9#pt9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURN ORBIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter61#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habitat "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Goddard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10#pt10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UNDERSTANDING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter62#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back to the City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter63#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gulf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter64#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter65#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter66#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reaction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter67#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suspicion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter68#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter69#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conflict")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter70#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter71#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter72#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Verify")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter73#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Factions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter74#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11#pt11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXOPLANET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter75#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homeworld")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12#pt12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRUSADERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter76#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Base Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter77#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One on One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter78#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Their Fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter79#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aliens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter80#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reconciliation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-pt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part13#pt13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter81#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight Years and Eight Months Later")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Death Wave")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tor Books by Ben Bova")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0